<template>
    <div class="page">
        <p>
            {{ creditor.creditor_name }}
            <br /> {{ creditor.address_line }}
            <br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            <br />
            <br /> Date: {{ date }}
            <br />
            <br /> RE: Account: # {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}
        </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            I recently received a letter from your company in an attempt to collect information to verify a debt. Since your letter states that you’ve actually received my dispute from the credit bureaus regarding this account, then you must already have my social security number, my full name, as well as the full account number and any other pertinent details for this item in which you allege I owe or else you wouldn’t be reporting it. Am I correct? Of course I am. So how can you ask me to HELP you prove that you have made a HUGE mistake?
        </p>
        <p class="letter-content">
            What you should be sending me is a copy of the contract I signed obligating me to this alleged debt. Or how about the proof of identity that I must have provided at the time of incurring this debt, as your company is required to obtain this identification per the Patriot Act.
        </p>
        <p class="letter-content">
            Where is it? You do not have it and so you must remove this account from my credit reports right away.
        </p>
        <p class="letter-content">
            Because you are unable to provide sufficient verification of this account, I request that you cease all collection activity immediately, including any negative reporting to the credit bureaus in which you may have already submitted.
        </p>
        <p class="letter-content">
            If you refuse to do so, I will forward this and all correspondences to my legal counsel for an escalated resolution to this matter. Thank you.
        </p>
        <p>
            Thank you for your time and attention to this matter.
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>